import React, { SyntheticEvent } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { PersonExtended } from "../../../Utils/TypeExtensions";
import { IntegerCustomControlProps } from "../../../Utils/Interfaces";
import { useLiveQuery } from "dexie-react-hooks";
import { TicketDatabase } from "../../../Utils/TicketDatabase";
import { CONTROL_MARGIN } from "../../../MuiThemes";
import { getHelperText, propertyHasErrors } from "../inputHelpers";

export default function AmeSelector(props: IntegerCustomControlProps): JSX.Element {
    const ameList = useLiveQuery(async () => TicketDatabase.ame.toArray());

    if (!ameList) return <></>;

    const sortedByName = ameList.sort((a: PersonExtended, b: PersonExtended) => {
        return (a.selectName ?? "").localeCompare(b.selectName ?? "");
    });

    const initialValue = sortedByName.find((p) => p.id === props.initialValue);

    // TODO could extract the textfield to a common component, they all use the same props I think
    return (
        <>
            <Autocomplete
                disabled={props.isDisabled}
                value={initialValue === undefined ? null : initialValue}
                options={sortedByName}
                onChange={handleOnChange}
                getOptionLabel={(option: PersonExtended) => option.selectName ?? ""}
                filterSelectedOptions
                renderInput={(params) => (
                    <TextField
                        {...params}
                        required={props.isRequired}
                        error={propertyHasErrors(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                        helperText={getHelperText(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                        margin={CONTROL_MARGIN}
                        label={props.labelText}
                        placeholder="type to search"
                    />
                )}
            />
        </>
    );

    function handleOnChange(e: SyntheticEvent, value: string | PersonExtended | null) {
        let newId;
        if (value !== null) {
            newId = (value as PersonExtended).id;
        }

        props.mergeChanges(props.sourceId, { [props.sourceProperty]: newId });
    }
}
